import gql from 'graphql-tag'

export const newPolicyCheck = gql`
  mutation($policyCheckInput: NewPolicyCheckInput!) {
    newPolicyCheck(
      policyCheckInput: $policyCheckInput
    ) {
      createdBy {
        id
        username
      }
      checkAt
      notes
    }
  }
`

export const getPolicyChecks = gql`
  query($policyId: Int!) {
    getPolicyChecks(
      policyId: $policyId
    ) {
      createdBy {
        id
        username
      }
      checkAt
      notes
    }
  }
`
